import { Loader } from 'components';
import { SignupUI } from 'features';
import { SignUpPayload, useSignUp } from 'hooks';
import { useState } from 'react';
import { EmailVerificationPrompt } from '../email-verification-prompt';

const Signup = () => {
  // States
  const [clear, setClear] = useState(false);
  const [success, setSuccess] = useState(false);
  const [email, setEmail] = useState('');

  // Hooks
  const { mutate: signup, isPending } = useSignUp(setSuccess, setClear, setEmail);

  const submit = (data: SignUpPayload) => {
    signup(data);
  };

  return (
    <>
      <Loader loading={isPending} />
      <SignupUI submit={submit} clear={clear} />
      <EmailVerificationPrompt
        email={email}
        show={success}
        close={() => setSuccess(false)}
      />
    </>
  );
};

export { Signup };